import { render, staticRenderFns } from "./HspLayout.vue?vue&type=template&id=e64a1994"
import script from "./HspLayout.vue?vue&type=script&lang=js"
export * from "./HspLayout.vue?vue&type=script&lang=js"
import style0 from "./HspLayout.vue?vue&type=style&index=0&id=e64a1994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports